import { Grid, Stack } from "@mui/material";
import { Formik, Form } from "formik";
import { useState } from "react";
import Dropdown2 from "../elements/Dropdown2";
import InputField from "../elements/InputField";
import CustomButton from "../elements/CustomButton";
import QuestionTypeSection from "./QuestionTypeSection";
import CategoryModal from "./CategoryModal";
import { questionTypeOptions } from "../../staticData/tableHead";

const QuestionForm = ({
  onSubmit,
  categories,
  onAddCategory,
  initialValues,
}) => {
  const [openCategoryModal, setOpenCategoryModal] = useState(false);

  const categoryOptions = categories.map((cat) => ({
    value: cat.id,
    label: cat.name,
  }));

  const defaultValues = {
    category: "",
    title: "",
    description: "",
    questionType: "",
    options: [],
    textfieldConfig: { label: "", placeholder: "" },
  };

  return (
    <Formik
      initialValues={initialValues || defaultValues}
      enableReinitialize={true}
      onSubmit={(values) => {
        onSubmit(values);
      }}
    >
      {({ handleBlur, handleChange, handleSubmit, values, setFieldValue }) => (
        <>
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Category */}
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Dropdown2
                    elementName="category"
                    selected={values.category}
                    handleChange={handleChange}
                    elementLabel="Category"
                    options={categoryOptions}
                    required
                  />
                </Stack>
              </Grid>

              {/* Question Title */}
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Question Title"
                    id="title"
                    type="text"
                    value={values.title}
                    name="title"
                    fullWidth
                    placeholder="Question Title"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        fontSize: "1rem",
                      },
                    }}
                  />
                </Stack>
              </Grid>

              {/* Description */}
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Description (optional)"
                    id="description"
                    type="text"
                    value={values.description}
                    name="description"
                    fullWidth
                    rows={3}
                    multiline
                    placeholder="Enter question description"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        fontSize: "1rem",
                      },
                    }}
                  />
                </Stack>
              </Grid>

              {/* Question Type */}
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Dropdown2
                    elementName="questionType"
                    selected={values.questionType}
                    handleChange={handleChange}
                    elementLabel="Question Type"
                    options={questionTypeOptions}
                    required
                  />
                </Stack>
              </Grid>

              {/* Question Type Specific Fields */}
              <QuestionTypeSection
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
              />

              {/* Submit */}
              <Grid item xs={12}>
                <CustomButton />
              </Grid>
            </Grid>
          </Form>

          {/* Category Modal */}
          <CategoryModal
            open={openCategoryModal}
            handleClose={() => setOpenCategoryModal(false)}
            onAddCategory={onAddCategory}
            setFieldValue={setFieldValue}
          />
        </>
      )}
    </Formik>
  );
};

export default QuestionForm;